/* @jsx h */
import { defineComponent, h, type Ref } from "vue";
import {
  type FloorPlan,
  type TableStatus,
  type Reservation,
  type ReservationRequest,
} from "@lemmonhq/types";
import { FloorPlanHeader } from "./FloorPlanHeader";
import { type FloorPlanViewMode, type DropModeState } from "../tables-types";

export const TablesHeader = defineComponent<{
  currentView: Ref<string>;
  searchQuery: Ref<string>;
  filter: Ref<string>;
  tables: Ref<TableStatus[]>;
  floorPlans: Ref<FloorPlan[]>;
  activeFloorPlan: Ref<string | undefined>;
  isDirty: Ref<boolean>;
  onSave: () => void;
  onReset: () => void;
  onFloorPlanSelect: (id: string) => void;
  onFloorPlanCreated: () => void;
  isLoading: Ref<boolean>;
  fetchTables: Function;
  floorPlanViewMode: Ref<FloorPlanViewMode>;
  dropModeState: Ref<DropModeState>;
  onEnterDropMode: (reservation: Reservation) => void;
  onExitDropMode: () => void;
  onConfirmDropMode: (action?: "seat" | "assign") => void;
  reservations?: Ref<Reservation[]>;
  confirmedCount: number | null;
  pendingCount: number | null;
  seatedCount: number | null;
  selectedDate: Ref<Date>;
  onDateChange: (date: Date) => void;
  isSelectedToday: Ref<boolean>;
  onEnterReservationMode: () => void;
  onExitReservationMode: () => void;
  onOpenReservationList: (tab: "confirmed" | "pending" | "seated") => void;
  onShowReservationDetail: (reservation: Reservation) => void;
  onShowRequestDetail: (request: ReservationRequest) => void;
}>({
  name: "TablesHeader",
  props: [
    "currentView",
    "searchQuery",
    "filter",
    "tables",
    "floorPlans",
    "activeFloorPlan",
    "isDirty",
    "onSave",
    "onReset",
    "onFloorPlanSelect",
    "onFloorPlanCreated",
    "isLoading",
    "fetchTables",
    "floorPlanViewMode",
    "dropModeState",
    "onEnterDropMode",
    "onExitDropMode",
    "onConfirmDropMode",
    "reservations",
    "confirmedCount",
    "pendingCount",
    "seatedCount",
    "selectedDate",
    "onDateChange",
    "isSelectedToday",
    "onEnterReservationMode",
    "onExitReservationMode",
    "onOpenReservationList",
    "onShowReservationDetail",
    "onShowRequestDetail",
  ],
  setup(props) {
    return () => (
      <div class="mb-0 flex gap-4">
        <FloorPlanHeader
          tables={props.tables}
          floorPlans={props.floorPlans}
          currentView={props.currentView}
          activeFloorPlan={props.activeFloorPlan}
          isDirty={props.isDirty}
          onSave={props.onSave}
          onReset={props.onReset}
          onFloorPlanSelect={props.onFloorPlanSelect}
          onFloorPlanCreated={props.onFloorPlanCreated}
          isLoading={props.isLoading}
          fetchTables={props.fetchTables}
          floorPlanViewMode={props.floorPlanViewMode}
          dropModeState={props.dropModeState}
          onEnterDropMode={props.onEnterDropMode}
          onExitDropMode={props.onExitDropMode}
          onConfirmDropMode={props.onConfirmDropMode}
          searchQuery={props.searchQuery}
          filter={props.filter}
          reservations={props.reservations}
          confirmedCount={props.confirmedCount}
          pendingCount={props.pendingCount}
          seatedCount={props.seatedCount}
          selectedDate={props.selectedDate}
          onDateChange={props.onDateChange}
          isSelectedToday={props.isSelectedToday}
          onEnterReservationMode={props.onEnterReservationMode}
          onExitReservationMode={props.onExitReservationMode}
          onOpenReservationList={props.onOpenReservationList}
          onShowReservationDetail={props.onShowReservationDetail}
          onShowRequestDetail={props.onShowRequestDetail}
        />
      </div>
    );
  },
});
